import { wrap } from "../_"

const pfx = "/instagram"

export default (a: NuxtAxiosInstance) => ({
  getPosts: (cfg?: AxiosConfig) => wrap(
    a.$get(`${pfx}/posts`,
      { cache: true, ...cfg })),
})
